import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

// TODO: the overflow-item margin-left is a temporary fix before it's in SDS
export const formField = css`
    margin-bottom: ${Spacing.XS}px;

    textarea {
        font-family: inherit;
    }

    .ant-select-selection-overflow-item:first-of-type {
        margin-left: 0 !important;
    }
`;
